<template>
    <div
        class="empty-results relative flex flex-col items-center justify-center pt-12"
        v-if="totalResults > 0 && !filteredAndPaginatedSearchResults.length"
    >
        <div
            class="w-16 h-16 bg-slate-200 rounded-full justify-center items-center gap-2.5 inline-flex mb-5"
        >
            <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    id="vector"
                    d="M18.6663 9.33203H5.33301M18.6663 9.33203C18.6663 7.12203 20.4563 5.33203 22.6663 5.33203C24.8763 5.33203 26.6663 7.12203 26.6663 9.33203C26.6663 11.542 24.8763 13.332 22.6663 13.332C20.4563 13.332 18.6663 11.542 18.6663 9.33203ZM26.6663 22.6654H15.9997M15.9997 22.6654C15.9997 24.8754 14.2097 26.6654 11.9997 26.6654C9.78967 26.6654 7.99967 24.8754 7.99967 22.6654M15.9997 22.6654C15.9997 20.4554 14.2097 18.6654 11.9997 18.6654C9.78967 18.6654 7.99967 20.4554 7.99967 22.6654M7.99967 22.6654H5.33301"
                    stroke="#475569"
                    stroke-width="2.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
        <h5 class="text-slate-800 text-lg font-medium leading-7 mb-3">
            No matching hotels
        </h5>

        <p class="text-slate-500 text-sm font-normal leading-tight mb-7">
            Try removing some filters to see more hotels.
        </p>

        <button
            @click="handleClearFilters"
            role="button"
            class="px-4 py-2 bg-white rounded shadow border border-slate-200 text-slate-800 text-sm font-medium hover:bg-slate-50 transition-colors"
        >
            Clear filters
        </button>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useHotelsStore } from '@/store/hotels';
import { useUiStore } from '@/store/ui';
const hotelsStore = useHotelsStore();
const uiStore = useUiStore();
const { totalResults } = storeToRefs(uiStore);
const { searchCompleted, filteredAndPaginatedSearchResults } =
    storeToRefs(hotelsStore);

const handleClearFilters = () => {
    hotelsStore.clearHotelFilters();
};
</script>
